function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-141.386719 0-256 114.613281-256 256s114.613281 256 256 256 256-114.613281 256-256-114.613281-256-256-256zm1.878906 416.425781c-29.015625 0-129.367187-112.808593-129.367187-188.414062 0-72.363281 57.171875-132.4375 129.367187-132.4375 68.605469 0 125.777344 60.074219 125.777344 132.4375.003906 75.605469-100.347656 188.414062-125.777344 188.414062zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m258.21875 145.921875c-6.65625 0-12.972656.679687-18.945312 2.046875 8.707031 5.289062 14.507812 14.675781 14.507812 25.429688 0 16.722656-13.824219 30.207031-30.890625 30.207031-15.1875 0-27.648437-10.582031-30.378906-24.578125-8.703125 12.460937-13.824219 27.648437-13.824219 44.375 0 39.421875 34.644531 73.214844 79.53125 73.214844 40.449219 0 75.09375-33.792969 75.09375-73.214844 0-43.691406-34.644531-77.480469-75.09375-77.480469zm0 0"
});

function SvgPeriscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriscope);
export default __webpack_public_path__ + "static/media/Periscope.72cef023.svg";
export { ForwardRef as ReactComponent };